<template>
  <div class="title">
    <div class="cn" v-text="title.cn"></div>
    <div class="en" v-text="title.en"></div>
  </div>
</template>

<script>
export default {
  props: {
      title: Object
  }
}
</script>

<style scoped>
.title{
  text-align: center;
  color: #1e1e1e;
}
.title .cn{
    font-size: 30px;
}
.title .en{
    font-size: 15px;
    text-transform: uppercase;
}
</style>


